export default "__VITE_ASSET__QfJQ5E5m__"